import React from 'react';
import SectionContainer from './SectionContainer';
import { HStack, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import { text } from '@/theme/colors/palettes';

const LoadingSection = () => {
  return (
    <SectionContainer>
      <HStack width={'100%'} justify={'space-between'}>
        <SkeletonText
          noOfLines={2}
          height={'40px'}
          width={'75%'}
          startColor={text.mediumBlue}
          endColor={text.mediumGray}
        />
        <HStack alignItems={'center'} gap={3}>
          <SkeletonCircle height={'25px'} width={'25px'} startColor={text.mediumBlue} endColor={text.mediumGray} />
          <SkeletonText
            width={'40px'}
            height={'10px'}
            noOfLines={1}
            startColor={text.mediumBlue}
            endColor={text.mediumGray}
          />
        </HStack>
      </HStack>
      <SkeletonText
        width={'100%'}
        height={'40px'}
        noOfLines={2}
        startColor={text.mediumBlue}
        endColor={text.mediumGray}
      />
    </SectionContainer>
  );
};

export default LoadingSection;
